import { render, staticRenderFns } from "./tvItem.vue?vue&type=template&id=086cfd1c&scoped=true&"
import script from "./tvItem.vue?vue&type=script&lang=js&"
export * from "./tvItem.vue?vue&type=script&lang=js&"
import style0 from "./tvItem.vue?vue&type=style&index=0&id=086cfd1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086cfd1c",
  null
  
)

export default component.exports